export class UuidGenerator {
  constructor() {
    this.characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  }
  
  build(length = 10) {
    let uuid = ''
    for ( let i = 0; i < length; i++ ) {
      uuid += this.characters.charAt(Math.floor(Math.random() * this.characters.length));
    }
    return uuid
  }
}